export enum CadastroComentarioUsuarioTipo {
  CONSULTOR = 'CONSULTOR',
  CLIENTE = 'CLIENTE',
  USUARIO_BACKOFFICE = 'USUARIO_BACKOFFICE',
}
